import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./assets/styles/index.css";
import {
  I18nextProvider,
  initReactI18next,
  useTranslation,
} from "react-i18next";
import i18next from "i18next";
import { resources } from "./assets/locals";
import environment from "./environment";
import { Provider } from "react-redux";
import store from "./store";
i18next.use(initReactI18next).init({
  interpolation: { escapeValue: false },
  lng: localStorage.getItem(environment.lang) || "ar",
  resources,
});

const MainApp = () => {
  const { i18n } = useTranslation();
  if (i18n.language === "ar") {
    import("bootstrap/dist/css/bootstrap.rtl.min.css");
  } else {
    import("bootstrap/dist/css/bootstrap.min.css");
  }

  return (
    <Provider store={store}>
      <I18nextProvider i18n={i18next}>
        <div dir={i18n?.language === "ar" ? "rtl" : "ltr"}>
          <App />
        </div>
      </I18nextProvider>
    </Provider>
  );
};
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<MainApp />);
